<template>
  <div>
    <e-update-status-modal
      :isOn="hasDialogs.remind"
      actionName="remind"
      @closeModal="closeModal('remind')"
      @submitAction="remind"
      :disabled="buttonDisabled"
    />
    <e-update-status-modal
      :isOn="hasDialogs.remindIPN"
      actionName="remindIPN"
      @closeModal="closeModal('remindIPN')"
      @submitAction="remindIPN"
      :disabled="buttonDisabled"
    />
    <v-layout row class="my-4">
      <v-flex xs2>
        <v-select
          :items="status.transactionType"
          v-model="filter.transactionType"
          label="Filter by Transaction Type"
        />
      </v-flex>
      <v-flex xs2>
        <v-select
          class="mx-4"
          :items="status.paymentProvider"
          v-model="filter.paymentProvider"
          label="Filter by Payment Provider"
        />
      </v-flex>
    </v-layout>
    <v-layout row class="my-4">
      <v-flex xs12>
        <v-layout>
          <v-text-field
            append-icon="search"
            label="Search for first name"
            v-model="search.firstName"
          />
          <v-text-field
            class="ml-4"
            append-icon="search"
            label="Search for last name"
            v-model="search.lastName"
          />
          <v-text-field
            class="ml-4"
            append-icon="search"
            label="Search for email"
            v-model="search.email"
          />
          <v-text-field
            class="ml-4"
            append-icon="search"
            label="Search for company"
            v-model="search.company"
          />
          <v-text-field
            class="ml-4"
            append-icon="search"
            label="Search for Payment Provider Transaction Id"
            v-model="search.paymentProviderTransactionId"
          />
        </v-layout>
      </v-flex>
      <v-flex xs1 class="my-2 mx-2">
        <v-btn color="primary" @click.stop="reset">Reset</v-btn>
      </v-flex>
    </v-layout>
    <v-layout row class="my-4">
      <v-flex xs2>
        <v-btn @click="downloadExcel" :disabled="isDownloadButtonDisabled">Download Excel Invoices</v-btn>
      </v-flex>
    </v-layout>
    <v-data-table
      v-if="isLoadTable"
      v-model="selectedID"
      :headers="headers"
      :items="getInvoices"
      :pagination.sync="pagination"
      :total-items="getTotalItemsInvoices"
      :loading="isLoading"
      :disable-initial-sort="true"
      select-all
      class="elevation-1"
      item-key="paymentProviderTransactionId"
    >
      <template slot="headers" slot-scope="props">
        <tr>
          <th>
            <v-checkbox
              :input-value="props.all"
              :indeterminate="props.indeterminate"
              primary
              hide-details
              @click.native="toggleAll"
            />
          </th>
          <th
            v-for="header in props.headers"
            :key="header.text"
            :class="['column sortable', pagination.descending ? 'desc' : 'asc', header.value === pagination.sortBy ? 'active' : '']"
            @click="changeSort(header.value)"
          >
            {{ header.text }}
            <v-icon v-if="header.sortable" small>arrow_upward</v-icon>
          </th>
        </tr>
      </template>

      <template slot="items" slot-scope="props">
        <tr :active="props.selected" @click="toggleSelect(props)">
          <td>
            <v-checkbox
              :input-value="props.selected"
              primary
              hide-details
            />
          </td>
          <td class="text-xs">{{props.item.attendeeFirstName}}</td>
          <td class="text-xs">{{props.item.attendeeLastName}}</td>
          <td class="text-xs">{{props.item.attendeeEmail}}</td>
          <td class="text-xs">{{props.item.company}}</td>
          <td class="text-xs">{{props.item.packageName}}</td>
          <td class="text-xs">{{props.item.packageTitle}}</td>
          <td class="text-xs-center">{{props.item.ticketsQuantity}}</td>
          <td class="text-xs-center">{{props.item.packagePrice}}</td>
          <td class="text-xs-center">{{props.item.transactionAmount}}</td>
          <td class="text-xs-center">{{props.item.transactionType}}</td>
          <td class="text-xs-center">{{props.item.paymentProvider}}</td>
          <td class="text-xs-center">{{props.item.paymentProviderTransactionId}}</td>

          <td class="text-xs-center">
            <v-tooltip bottom>
              <v-btn
                fab flat
                color="info"
                slot="activator"
                @click="downloadIPN(props.item)"
                :disabled="!isWriteAvailable"
              >
                <v-icon>insert_drive_file</v-icon>
              </v-btn>
              <span>Pre default PDF</span>
            </v-tooltip>
          </td>
          <td class="text-xs-center">
            <v-tooltip bottom>
              <v-btn
                fab flat
                color="info"
                slot="activator"
                @click="downloadPDF(props.item)"
                :disabled="!isWriteAvailable"
              >
                <v-icon>insert_drive_file</v-icon>
              </v-btn>
              <span>Pre default PDF</span>
            </v-tooltip>
          </td>
          <td class="text-xs-center">
            <v-tooltip bottom>
              <v-btn
                fab flat
                color="info"
                slot="activator"
                @click="openModal('remindIPN', props.item.paymentProviderTransactionId)"
                :disabled="!isWriteAvailable"
              >
                <v-icon>email</v-icon>
              </v-btn>
              <span>Resend Email</span>
            </v-tooltip>
          </td>
          <td class="text-xs-center">
            <v-tooltip bottom>
              <v-btn
                fab flat
                color="info"
                slot="activator"
                @click="openModal('remind', props.item.paymentProviderTransactionId)"
                :disabled="!isWriteAvailable"
              >
                <v-icon>email</v-icon>
              </v-btn>
              <span>Resend Email</span>
            </v-tooltip>
          </td>
        </tr>
      </template>
      <template slot="no-data">
        <v-alert :value="true" color="error" icon="warning">
          Sorry, nothing to display here :(
        </v-alert>
      </template>
    </v-data-table>
  </div>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex'
  import debounce from 'lodash.debounce'
  import { timeSettings } from '@/modules/settings/'
  import { contains, equals, path, pathOr } from 'ramda'
  import mixins from '@/utils/mixins'
  import EUpdateStatusModal from './changeStatusModal'

  export default {
    name: 'InvoicesAndIPN',
    components: {
      EUpdateStatusModal
    },
    mixins: [mixins.isWriteAvailable],
    data () {
      return {
        isLoading: true,
        isLoadTable: false,
        pagination: {
          page: 1,
          rowsPerPage: 10
        },
        activeStatus: '',
        search: {
          firstName: '',
          lastName: '',
          email: '',
          company: '',
        },
        filter: {
          transactionType: '',
          paymentProvider: ''
        },
        status: {
          transactionType: ['Deposit', 'Refund'],
          paymentProvider: ['PayPal', 'BlueSnap']
        },
        selectedID: [],
        thisPaymentProviderTransactionId: '',
        hasDialogs: {
          remind: false,
          remindIPN: false
        },
        buttonDisabled: false,
        headers: [
          { text: 'First Name', align: 'left', value: 'attendeeFirstName', search: true, sortable: true, width: 150 },
          { text: 'Last Name', align: 'left', value: 'attendeeLastName', search: true, sortable: true, width: 250 },
          { text: 'Email', value: 'attendeeEmail', search: true, sortable: true, width: 250 },
          { text: 'Company', align: 'left', value: 'company', search: true, sortable: true, width: 250 },
          { text: 'Package Name', value: 'packageName', search: true, sortable: true, width: 150 },
          { text: 'Package Title', value: 'packageTitle', search: false, sortable: false },
          {
            text: 'Tickets Quantity',
            value: 'ticketsQuantity',
            search: false,
            sortable: false,
            align: 'center'
          },
          { text: 'Package Price', value: 'packagePrice', search: false, sortable: false },
          { text: 'Transaction Amount', value: 'transactionAmount', search: false, sortable: false },
          { text: 'Transaction Type', value: 'transactionType', search: false, sortable: false },
          {
            text: 'Payment Provider',
            value: 'paymentProvider',
            search: false,
            sortable: false,
            align: 'center'
          },
          {
            text: 'Payment Provider Transaction Id',
            value: 'paymentProviderTransactionId',
            search: true,
            sortable: false,
            align: 'center'
          },
          {
            text: 'Download IPNs PDF',
            value: 'downloadIPNsExcel',
            search: false,
            sortable: false,
            align: 'center'
          },
          {
            text: 'Download PDF Invoices',
            value: 'downloadPDFInvoices',
            search: false,
            sortable: false,
            align: 'center'
          },
          {
            text: 'Resend IPNs',
            value: 'resendIPNs',
            search: false,
            sortable: false,
            align: 'center'
          },
          {
            text: 'Resend Invoices',
            value: 'resendInvoices',
            search: false,
            sortable: false,
            align: 'center'
          }
        ],
        scopeForWrite: 'registration:write'
      }
    },
    computed: {
      ...mapGetters([
        'getInvoices',
        'getTotalItemsInvoices'
      ]),
      isDownloadButtonDisabled () {
        return this.selectedID.length === 0
      }
    },
    watch: {
      search: {
        handler () {
          this.getDataFromApi()
        },
        deep: true
      },
      filter: {
        handler () {
          this.getDataFromApi()
        },
        deep: true
      },
      pagination: {
        handler (val, oldVal) {
          if (val.totalItems !== oldVal.totalItems) return
          this.getDataFromApi()
        },
        deep: true
      }
    },
    methods: {
      contains,
      ...mapActions([
        'fetchInvoices',
        'resendInvoices',
        'downloadInvoicePDF',
        'downloadInvoicesExcel',
        'showResultErrorMessage',
        'downloadIPNpdf',
        'resendIPN'
      ]),
      toggleSelect (props) {
        return props.selected = !props.selected
      },
      toggleAll () {
        if (this.selectedID.length) {
          this.selectedID = []
        } else {
          this.selectedID = [...this.getInvoices]
        }
      },
      changeSort (column) {
        if (this.pagination.sortBy === column) {
          this.pagination.descending = !this.pagination.descending
        } else {
          this.pagination.sortBy = column
          this.pagination.descending = false
        }
      },
      sortingDirection (dir) {
        return dir ? 'Desc' : 'Asc'
      },
      async reset () {
        Object.keys(this.search).forEach(val => this.search[val] = '')
        Object.keys(this.filter).forEach(val => this.filter[val] = '')
        this.pagination = {
          page: 1,
          rowsPerPage: 10,
          sortBy: null,
          descending: false
        }
        await this.getDataFromApi()
      },
      getDataFromApi: debounce(async function () {
        this.isLoading = true
        const { sortBy, descending, page, rowsPerPage } = this.pagination
        const sortByValue = sortBy ? sortBy[0].toUpperCase() + sortBy.slice(1) : null
        const newPage = page - 1
        const pageCheck = newPage > 0 ? newPage : 0
        const filterFirstName = {
          searchValue: this.search.firstName,
          filterBy: 'AttendeeFirstName'
        }
        const filterLastName = {
          searchValue: this.search.lastName,
          filterBy: 'AttendeeFirstName'
        }
        const filterEmail = {
          searchValue: this.search.email,
          filterBy: 'AttendeeEmail'
        }
        const filterCompany = {
          searchValue: this.search.company,
          filterBy: 'Company'
        }
        const filterPaymentProviderTransactionId = {
          searchValue: this.search.paymentProviderTransactionId,
          filterBy: 'ExternalId'
        }
        const sorter = {
          direction: this.sortingDirection(descending),
          sortByValue
        }
        const equalsTransactionType = {
          status: this.filter.transactionType,
          filterBy: 'TransactionType'
        }
        const equalsPaymentProvider = {
          status: this.filter.paymentProvider,
          filterBy: 'PaymentProvider'
        }
        const getParams = {
          page: pageCheck,
          itemsOnPage: equals(rowsPerPage, -1) ? this.getTotalItemsInvoices : rowsPerPage,
          filterFirstName,
          filterLastName,
          filterEmail,
          filterCompany,
          filterPaymentProviderTransactionId,
          equalsTransactionType,
          equalsPaymentProvider,
          sorter
        }
        try {
          await this.fetchInvoices(getParams)
          this.isLoadTable = true
        } catch (e) {
          console.error(e)
        } finally {
          this.isLoading = false
        }
      }, timeSettings.delayTime),
      async remind () {
        this.buttonDisabled = true
        try {
          await this.resendInvoices(this.thisPaymentProviderTransactionId)
        } catch (err) {
          this.showResultErrorMessage(err.message)
        } finally {
          this.closeModal('remind')
          this.buttonDisabled = false
        }
      },
      async remindIPN () {
        this.buttonDisabled = true
        try {
          await this.resendIPN(this.thisPaymentProviderTransactionId)
        } catch (err) {
          this.showResultErrorMessage(err.message)
        } finally {
          this.closeModal('remindIPN')
          this.buttonDisabled = false
        }
      },
      openModal (action, editItem) {
        this.hasDialogs[action] = true
        this.thisPaymentProviderTransactionId = editItem
      },
      closeModal (typeOfAction) {
        this.hasDialogs[typeOfAction] = false
        this.thisPaymentProviderTransactionId = ''
      },
      downloadPDF ({ paymentProviderTransactionId, attendeeFirstName, attendeeLastName }) {
        this.downloadInvoicePDF({id: paymentProviderTransactionId, name: `${attendeeFirstName} ${attendeeLastName}`})
      },
      downloadIPN ({ paymentProviderTransactionId, attendeeFirstName, attendeeLastName }) {
        this.downloadIPNpdf({id: paymentProviderTransactionId, name: `${attendeeFirstName} ${attendeeLastName}`})
      },
      async downloadExcel () {
        try {
          const selected = this.selectedID.map(val => val.paymentProviderTransactionId)
          await this.downloadInvoicesExcel(selected)
          this.selectedID = []
        } catch (err) {
          this.showResultErrorMessage(err.message)
        }
      }
    },
    created () {
      this.getDataFromApi()
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/pages/Registration/Invoices/index.vue